import * as React from 'react';
type Props = {
  className?: string;
};
export function SaveMoney({ className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 48 48"
      fill="none"
      data-testid="utility-save-money"
      className={className}
    >
      <path
        d="M26.3591 29.3353C28.1868 29.3353 31.0736 29.6632 31.8421 29.3353C32.5787 29.021 32.8221 28.1235 32.6124 27.4668C32.4009 26.8044 31.7555 26.5459 31.6608 26.5097C30.0144 26.3579 28.3681 26.2059 26.7217 26.054C24.1842 25.6439 23.2926 26.529 23.2926 26.529L19.0826 29.3421L17.8565 30.6136C17.1075 31.4158 13.2784 37.4319 5.80469 40.8255"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M11.5654 46.5855C15.602 44.8106 19.6829 35.2994 24.1479 34.6857L32.5581 33.8134C33.3143 33.7179 35.0116 33.3493 36.4259 31.5177L41.0583 26.5132C42.285 25.1807 41.8705 23.7775 40.7578 23.577C40.7578 23.577 40.1032 23.3765 39.0794 23.9879L32.693 27.3855"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M30.6859 20.6801C36.1636 20.6801 40.6042 16.4863 40.6042 11.3128C40.6042 6.13945 36.1636 1.94556 30.6859 1.94556C25.2082 1.94556 20.7676 6.13945 20.7676 11.3128C20.7676 16.4863 25.2082 20.6801 30.6859 20.6801Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M33.2712 8.0409C33.2038 7.90377 32.791 6.60023 31.0994 6.38293C30.9938 6.3694 29.3599 6.12129 28.4488 7.35162C28.3829 7.44057 27.582 8.56026 28.1095 9.71845C28.5233 10.6274 29.4396 11.1015 30.6866 10.9935C31.2631 10.9911 31.6064 10.7637 32.3593 10.9778C33.1942 11.2153 33.6544 11.8485 33.9047 12.6862C34.3012 14.0128 33.2288 15.0034 33.0036 15.1608C31.8263 15.9842 29.6643 16.0493 28.4043 14.3296"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M30.6865 4.1496V17.9251"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  );
}
